/**
 * Canonical slug lists with NO `@/` alias imports, so they can be imported
 * by vite.config.ts (which loads before the alias is registered) to drive
 * SSG pre-rendering of dynamic content routes.
 */
export const PRODUCT_SLUGS = [
	"shalosh-bayom",
	"agua-vita",
	"dermogel",
	"taftefet",
	"lazihum",
	"nazelet",
	"jabon-neutro",
	"te"
] as const

export const TREATMENT_SLUGS = [
	"acidez",
	"acne",
	"ansiedad",
	"artritis",
	"amenorrea",
	"asma",
	"bronquitis",
	"cancer",
	"cataratas",
	"conjuntivitis",
	"dermatitis",
	"diabetes",
	"diabetes-tipo-2",
	"envejecimiento-prematuro",
	"estrenimiento",
	"heridas",
	"menopausia",
	"parkinson",
	"prostatitis",
	"sobrepeso",
	"vph"
] as const

export const SERVICE_SLUGS = ["dieta-personalizada", "consulta-remota"] as const
